import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
};

const setData = (store, data) => {
  store.setState((state) => {
    state.modulo.socios.upsert.data = { ...data };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.socios.upsert = { ...state.modulo.socios.upsert, ...data };
  });
};

const upsert = async (store, meta = {}, id) => {
  store.setState((state) => {
    state.modulo.socios.upsert.busy = true;
  });

  try {
    let response;

    if (!id) {
      response = await Http.post(`api/socios`, meta);
    } else {
      response = await Http.put(`api/socios/${id}`, {
        ...meta,
        hits: undefined,
      });
    }

    store.setState((state) => {
      state.modulo.socios.upsert.busy = false;
      state.modulo.socios.upsert.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.socios.upsert.busy = false;
      state.modulo.socios.upsert.error = error.data || error;
    });
  }
};

const resetError = (store) => (state) => {
  state.modulo.socios.upsert.error = undefined;
};

const reset = (store) => (state) => {
  state.modulo.socios.upsert = { ...initialState };
};

const actions = {
  setData,
  change,
  upsert,
  resetError,
  reset,
};

const SociosDeNegocioUpsertStore = {
  state: () => initialState,
  actions,
};

export default SociosDeNegocioUpsertStore;
